module.exports = "/packs/5-c4879a0d314ae4ab5d85ffa82bf79ffc.svg";